import { render, staticRenderFns } from "./DevolucionHistoricoPrefacturas.vue?vue&type=template&id=1e5e30ce"
import script from "./DevolucionHistoricoPrefacturas.vue?vue&type=script&lang=js"
export * from "./DevolucionHistoricoPrefacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports